module.exports = __webpack_public_path__ + "static/media/footer_bg_old.316b7b36.png";